// extracted by mini-css-extract-plugin
export var dayLabel = "_ko-0";
export var pickerDisabled = "_ko-1";